import { gql } from '@apollo/client';

export const GET_LIST_USERS_ROLE = gql`
  query GetList($where: Map, $sort: Map, $offset: Int, $limit: Int) {
    GetUserRoleList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on UserRoles {
        data {
          id
          user_id
          user {
            ... on User {
              id
              name
              email
              phone_number
              active_status
              created_at
              updated_at
              deleted_at
              profile_pic_document_id
              profile_pic_document {
                ... on Document {
                  id
                  name
                  object_name
                  bucket_name
                }
              }
              roles {
                ... on PaginationResponse {
                  count
                }
                ... on Roles {
                  data {
                    id
                    slug
                    name
                    scope
                    created_at
                    updated_at
                    deleted_at
                  }
                }
              }
            }
          }
          role_id
          role {
            ... on Role {
              id
              slug
              name
              scope
              description
              created_at
              updated_at
              deleted_at
            }
          }
          created_at
          updated_at
          deleted_at
        }
      }
    }
  }
`;

export const GET_LIST_USERS = gql`
  query GetList($where: Map, $sort: Map, $offset: Int, $limit: Int) {
    GetUserList(
      pagination: { offset: $offset, limit: $limit, where: $where, sort: $sort }
    ) {
      ... on PaginationResponse {
        count
      }
      ... on Users {
        data {
          id
          name
          phone_number
          email
          active_status
          created_at
          updated_at
          deleted_at
          roles {
            ... on PaginationResponse {
              count
            }
            ... on Roles {
              data {
                id
                slug
                name
                scope
                created_at
                updated_at
                deleted_at
              }
            }
          }
        }
      }
    }
  }
`;

export const GET_ME_USERS = gql`
  query {
    me {
      id
      name
      email
      active_status
      phone_number
      created_at
      updated_at
      profile_pic_document_id
      profile_pic_document {
        ... on Document {
          id
          name
          file_size
          file_type
          object_name
          bucket_name
          url_link
          created_at
          deleted_at
          updated_at
        }
      }
    }
  }
`;
